import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { 
  ODataClient,
  ODataEntityService, 
  ODataEntity, 
  ODataEntities, 
  ODataProperty, 
  EntityKey,
  Duration,
  ODataEntityResource,
  ODataEntitySetResource,
  ODataNavigationPropertyResource,
  ODataActionResource,
  ODataFunctionResource,
  HttpOptions
} from 'angular-odata';

//#region ODataApi Imports
import { Aktie } from '../entities/boerse/aktie.entity';
import { GroupAktie } from '../entities/boerse/groupaktie.entity';
import { Group } from '../entities/schema/group.entity';
import { Status } from '../entities/settings/status.entity';
import { StatusType } from '../entities/settings/statustype.entity';
//#endregion

@Injectable()
export class GroupAktieService extends ODataEntityService<GroupAktie> {
  constructor(protected client: ODataClient) {
    super(client, 'GroupAktie', 'entities.boerse.GroupAktie');
  }

  
  
  //#region ODataApi Actions
  //#endregion
  //#region ODataApi Functions
  //#endregion
  //#region ODataApi Navigations
  public aktie(entity: EntityKey<GroupAktie>): ODataNavigationPropertyResource<Aktie> {
    return this.entity(entity).navigationProperty<Aktie>('aktie');
  }
  public group(entity: EntityKey<GroupAktie>): ODataNavigationPropertyResource<Group> {
    return this.entity(entity).navigationProperty<Group>('group');
  }
  public status(entity: EntityKey<GroupAktie>): ODataNavigationPropertyResource<Status> {
    return this.entity(entity).navigationProperty<Status>('status');
  }
  public statusType(entity: EntityKey<GroupAktie>): ODataNavigationPropertyResource<StatusType> {
    return this.entity(entity).navigationProperty<StatusType>('statusType');
  }
  //#endregion
}
